import React from 'react';

import ClntImg1w from "./../Images/clients/test1.webp";
import ClntImg1 from "./../Images/clients/test1.png";
import ClntImg2w from "./../Images/clients/test2.webp";
import ClntImg2 from "./../Images/clients/test2.png";
import ClntImg3w from "./../Images/clients/test3.webp";
import ClntImg3 from "./../Images/clients/test3.png";
import ClntImg4w from "./../Images/clients/test4.webp";
import ClntImg4 from "./../Images/clients/test4.png";
import ClntImg5w from "./../Images/clients/test5.webp";
import ClntImg5 from "./../Images/clients/test5.png";
import ClntImg6w from "./../Images/clients/test6.webp";
import ClntImg6 from "./../Images/clients/test6.png";
import ClntImg7w from "./../Images/clients/test7.webp";
import ClntImg7 from "./../Images/clients/test7.png";
import ClntImg8w from "./../Images/clients/test8.webp";
import ClntImg8 from "./../Images/clients/test8.png";
import ClntImg9w from "./../Images/clients/test9.webp";
import ClntImg9 from "./../Images/clients/test9.png";
import ClntImg10w from "./../Images/clients/test10.webp";
import ClntImg10 from "./../Images/clients/test10.png";

const ClntList = [
    { srset1: ClntImg1w, srset2: ClntImg1, title: "Aries Container Terminal Private Limited", direct: "fade-down", delay: "0", },
    { srset1: ClntImg2w, srset2: ClntImg2, title: "Super Auto Forge", direct: "fade-up", delay: "0", },
    { srset1: ClntImg3w, srset2: ClntImg3, title: "Extra Co", direct: "fade-down", delay: "0", },
    { srset1: ClntImg4w, srset2: ClntImg4, title: "Maynee Cosmetology Clinic", direct: "fade-up", delay: "0", },
    { srset1: ClntImg5w, srset2: ClntImg5, title: "ANM Classes", direct: "fade-down", delay: "0", },
    { srset1: ClntImg6w, srset2: ClntImg6, title: "Let's Play", direct: "fade-up", delay: "200", },
    { srset1: ClntImg7w, srset2: ClntImg7, title: "Kans One", direct: "fade-down", delay: "200", },
    { srset1: ClntImg8w, srset2: ClntImg8, title: "Naturals Salon", direct: "fade-up", delay: "200", },
    { srset1: ClntImg9w, srset2: ClntImg9, title: "TONI&GUY", direct: "fade-down", delay: "200", },
    { srset1: ClntImg10w, srset2: ClntImg10, title: "Ever Bowl", direct: "fade-up", delay: "200", },
]

export default function Client() {
    return (
        <div className='clients-cont bg-pattern'>
            <div className='container-fluid sectin pb-6'>
                <h2 className='h1 fw-300 mb-8 txt-lg-center txt-lt' data-aos="fade-down" data-aos-once='true'>Trusted by</h2>
                <div className='mxw-700 m-lg-auto txt-lg-center txt-lt mb-8' data-aos="fade-down" data-aos-once='true'><p className='f-18 mb-0 line-ht-24'>Connected through continuous innovation and result-driven approach.</p></div>
                <ul className='row'>
                    {ClntList.map((item, index) => {
                        return (
                            <li key={index} className={`col-xl-2 col-lg-3 col-sm-5 col-9 client-list${index + 1}`} data-aos={item.direct} data-aos-once='true' data-aos-delay={item.delay}><div>
                                <picture>
                                    <source srcSet={item.srset1} type="image/webp" />
                                    <source srcSet={item.srset2} type="image/png" />
                                    <img src={item.srset2} alt={item.title} title={item.title} width="221" height="95" />
                                </picture></div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}
